import { render, staticRenderFns } from "./v-byline.vue?vue&type=template&id=f08a3586&scoped=true&"
import script from "./v-byline.vue?vue&type=script&lang=js&"
export * from "./v-byline.vue?vue&type=script&lang=js&"
import style0 from "./v-byline.vue?vue&type=style&index=0&id=f08a3586&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08a3586",
  null
  
)

export default component.exports